import banks from './banks.js'
import paymentGateways from './paymentGateways.js'
import cashBoxes from './cashBoxes.js'
import internalFundsTransfer from './internalFundsTransfer.js'
import receive from './receive.js'
import payment from './payment.js'
import cost from './cost.js'

export default {
  menu: 'Treasury',
  title: 'Treasury',

  banks,

  paymentGateways,

  cashBoxes,

  internalFundsTransfer,

  receive,

  payment,

  cost
}
